import { Injectable } from '@angular/core';
import {BaseRestService} from '../../shared/services/base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../../shared/models/send-back-result';
import {ArrayResponse, serializeQueryString} from '..';
import {CompaniesList} from '../../company/models/companies-list';
import {ContractLink, ContractLinkSummaries} from '../models/contract-link';

@Injectable({
  providedIn: 'root'
})
export class InvoicesManagementService  extends BaseRestService  {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }
  protected get className(): string { return 'ContractLinkServiceService'; }
  protected get isAnonymous(): boolean { return false; }



  // tslint:disable-next-line:no-any
  add(data: any): Observable<SendBackResult<boolean>> {
      return this.post<boolean>(`/Billings/InvoicesManagement`, data);

  }
}
